import { Fragment } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Outlet } from "react-router-dom";
import imagePath from "@/assets/images/midol-red.svg";

export default function AuthenticationLayout() {
  return (
    <Fragment>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            //  backgroundImage: `url(${imagePath})`,
            // backgroundRepeat: 'no-repeat',
            // backgroundColor: (t) =>
            //     t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            // backgroundSize: 'cover',
            // backgroundPosition: 'center',
            backgroundColor: "#fee300ff",
            justifyContent: "center",
            alignItems: "center",
          }}
          display={"flex"}
        >
          <img src={imagePath} style={{ width: "90%" }} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          display={"flex"}
          justifyContent="center"
        >
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}
